import { CustomSelectFieldProps, SelectField } from 'components/form'
import { TipoAcessoDomicilioEnum } from 'graphql/types.generated'

import { tipoAcessoDomicilioEnumRecord } from './condicoes-moradia-model'

type TipoAcessoDomicilioSelectFieldProps = CustomSelectFieldProps<TipoAcessoDomicilioEnum>

export function TipoAcessoDomicilioSelectField(props: TipoAcessoDomicilioSelectFieldProps) {
  return <SelectField<TipoAcessoDomicilioEnum> items={items} itemToString={itemToString} {...props} />
}

const items = Object.values(TipoAcessoDomicilioEnum)
const itemToString = (item: TipoAcessoDomicilioEnum) => item && tipoAcessoDomicilioEnumRecord[item]
